import Vue from 'vue';

Vue.component('back-to-top-component', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            visible: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        window.addEventListener('scroll', this.onScroll, { passive: true });
    },

    /**
     * Called before the Vue.js instance is destroyed.
     *
     * @return {void}
     */
    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll);
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        onScroll() {
            this.visible = window.scrollY > 200;
        },

        scrollToTop(event) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            event.currentTarget.blur();
        },
    },
});
